import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AssignmentCreateRequest,
  UserWhatsappAssignmentResponse,
  WhatsappPhoneResponse,
} from '../models/whatsapp.model';

@Injectable({ providedIn: 'root' })
export class WhatsappAssignmentApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/whatsapp`;

  assign(req: AssignmentCreateRequest): Observable<UserWhatsappAssignmentResponse> {
    return this.http.post<UserWhatsappAssignmentResponse>(
      `${this.base}/assignments`,
      req
    );
  }

  unassign(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/assignments/${id}`);
  }

  myPhones(): Observable<WhatsappPhoneResponse[]> {
    return this.http.get<WhatsappPhoneResponse[]>(`${this.base}/me/phones`);
  }

  myAssignments(): Observable<UserWhatsappAssignmentResponse[]> {
    return this.http.get<UserWhatsappAssignmentResponse[]>(
      `${this.base}/me/assignments`
    );
  }
}
